import React, { useState } from "react";
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import { Modal } from "react-bootstrap";

export default function AboutVideo() {
    const [modalShow, setModalShow] = useState(false);

  return (
    <>
    <section className="aboutpage-video">
        <div className="about-videobox">
            <span>Artful Textures</span>
            <Link onClick={() => { setModalShow(true);}} className="video-play-button"><span></span></Link>
            <span>Speak Beauty</span>
        </div>
              
        <img src="/image/aboutvideo-thumb.webp" className='img-responsive' alt="Video" loading="lazy"/>
    </section> 

      
    <Modal className="homevideo-popup" show={modalShow} onHide={() => setModalShow(false)} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Body>
            <button className="popup-close" onClick={() => setModalShow(false)}><Icons name="cross" /></button>
            <iframe
            className="video-player"
            src="https://www.youtube.com/embed/CY5Co014CM8?autoplay=1"
            allow="autoplay; encrypted-media"
            allowFullScreen
            title="Video"
            frameBorder="0"/>
        </Modal.Body>
    </Modal> 
    </>
  )
}
